module.exports = __webpack_public_path__ + "media/images/user/favicons/icon-36x36-41f4fd7833516caf354bd52b4fc07be5.png";